var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{staticClass:"checkbox",class:{ disabled: _vm.disabled, little: _vm.little },attrs:{"src":_vm.dynamicToggle},on:{"click":_vm.toggle}})}
var staticRenderFns = []

export { render, staticRenderFns }